<template>
  <v-dialog v-model="add_modal" max-width="1366" persistent>
    <v-card :loading="loading">
      <v-card-title>Add Cabinet</v-card-title>
      <v-card-text>
        <v-form>
          <v-row dense>
            <v-col>
              <v-text-field
                dense
                label="Name"
                v-model="form_data.name"
                :error-messages="form_error.name"
                :hide-details="!form_error.name"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            <v-col cols="1">
              <v-autocomplete
                dense
                label="Vendor"
                v-model="form_data.vendor_id"
                :items="vendor_list"
                :error-messages="form_error.vendor_id"
                :hide-details="!form_error.vendor_id"
                placeholder=" "
              >
                <template v-slot:selection="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ item.v_code }}</span>
                    </template>
                    <span>{{ item.text }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="
                          font-size: 0.8125rem;
                          font-weight: 500;
                          line-height: 1rem;
                        "
                        >No Vendor Found!</span
                      >
                      <span
                        @click="addVendor"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="
                          font-size: 1.5rem;
                          cursor: pointer;
                          color: #6e9a35 !important;
                        "
                      ></span>
                    </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-autocomplete
                dense
                label="Type"
                v-model="form_data.cabinet_type_id"
                :items="type_list"
                :error-messages="form_error.cabinet_type_id"
                :hide-details="!form_error.cabinet_type_id"
                placeholder=" "
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="1" style="max-width: 5.5%;">
              <v-text-field
                dense
                label="Width"
                v-model="form_data.width"
                :error-messages="form_error.width"
                :hide-details="!form_error.width"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            <v-col cols="1" style="max-width: 5.5%;">
              <v-text-field
                dense
                label="Depth"
                v-model="form_data.depth"
                :error-messages="form_error.depth"
                :hide-details="!form_error.depth"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            <v-col cols="1" style="max-width: 5.5%;">
              <v-text-field
                dense
                label="Height"
                v-model="form_data.height"
                :error-messages="form_error.height"
                :hide-details="!form_error.height"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            <v-col cols="1">
              <v-autocomplete
                dense
                label="Item"
                v-model="form_data.item_id"
                :items="item_list"
                item-text="item_name"
                item-value="item_id"
                hide-details
                placeholder=" "
              >
                <template v-slot:selection="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ item.short_name }}</span>
                    </template>
                    <span>{{ item.item_name }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="
                          font-size: 0.8125rem;
                          font-weight: 500;
                          line-height: 1rem;
                        "
                        >No Item Found!</span
                      >
                      <span
                        @click="addItem"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="
                          font-size: 1.5rem;
                          cursor: pointer;
                          color: #6e9a35 !important;
                        "
                      ></span>
                    </div>
                </template>
              </v-autocomplete>
            </v-col>
          
            <v-col cols="1" style="min-width: 9%;">
              <v-autocomplete
                dense
                label="Cabinet Line"
                v-model="form_data.cabinet_line_id"
                :items="line_list"
                :error-messages="form_error.cabinet_line_id"
                :hide-details="!form_error.cabinet_line_id"
                placeholder=" "
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="1" style="max-width: 5.5%;">
              <v-text-field
                dense
                label="List Px"
                v-model="form_data.list_px"
                :error-messages="form_error.list_px"
                :hide-details="!form_error.list_px"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            <v-col cols="1" style="max-width: 7%;">
              <v-switch
                class="pt-0 ma-0"
                v-model="form_data.accessory"
                label="ACC."
                color="success"
                dense=""
                hide-details
              ></v-switch>
            </v-col>
            
            <v-col cols="1" style="min-width: 9%;">
              <v-autocomplete
                dense
                label="Color"
                v-model="form_data.cabinet_color_id"
                :items="color_list"
                :error-messages="form_error.cabinet_color_id"
                :hide-details="!form_error.cabinet_color_id"
                placeholder=" "
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="1" style="max-width: 7.5%;">
              <v-switch
                class="pt-0 ma-0"
                v-model="form_data.modify"
                label="MDFY"
                color="success"
                dense=""
                hide-details
              ></v-switch>
            </v-col>
            <v-col cols="1" style="max-width: 5.5%;">
              <v-text-field
                dense
                label="Door"
                v-model="form_data.dr"
                :error-messages="form_error.dr"
                :hide-details="!form_error.dr"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            <v-col cols="1" style="max-width: 5.5%;">
              <v-text-field
                dense
                label="Drawer"
                v-model="form_data.drw"
                :error-messages="form_error.drw"
                :hide-details="!form_error.drw"
                placeholder=" "
              >
              </v-text-field>
            </v-col>
            
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn  color="primary" @click="saveCabinet()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import axios from "../../plugins/axios";
export default {
  name: "AddCabinet",
  data: () => ({
    loading: false,
    form_data: {
      accessory: false,
      modify: false
    },
    form_error: {},
    vendor_list: [],
    item_list: [],
    type_list: [],
    color_list: [],
    line_list: [],
  }),
  watch: {
    add_modal: {
      handler(val) {
        if (val) {
          this.form_data = {
            accessory: false,
            modify: false
          }
        }
      },
    },
  },
  computed: {
    ...mapState("cabinet", ["add_modal"]),
  },
  methods: {
    ...mapMutations("cabinet",['setData']),
    addItem() {
      this.$router.push({ path: "/items" });
    },
    addVendor() {
      this.$router.push({ path: "/vendors" });
    },
    saveCabinet() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("add_cabinet", serverData)
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.setData({ key: "add_modal", value: false });
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    closePopup() {
      this.setData({ key: "add_modal", value: false });
    },
    getVendors() {
      this.loading = false
      let _self = this;
      axios
        .get("get_cabinet_vendor")
        .then((response) => {
          console.log(response)
          _self.vendor_list = response.data.data;
          _self.loading = false
        })
        .catch(function () {
          _self.loading = false
        });
    },
    getItems() {
      this.loading = false
      let _self = this;
      axios
        .get("items_list?itemsPerPage=-1&item_type='0'")
        .then((response) => {
          _self.item_list = response.data.data.data;
        })
        .catch(function () {
          _self.loading = false
        });
    },
    getCabinetSelector() {
      this.loading = false
      let _self = this;
      axios
        .get("cabinet_selector")
        .then((response) => {
          _self.type_list = response.data.data.type;
          _self.color_list = response.data.data.color;
          _self.line_list = response.data.data.line;
          _self.loading = false
        })
        .catch(function () {
          _self.loading = false
        });
    }
  },
  mounted: function () {
    this.getVendors();
    this.getItems();
    this.getCabinetSelector();
  },
};
</script>

<style>
</style>